import { MEMBER_TYPE, } from "@erp/shared/components/ui/Dialog/MemberSearchDialog/member.types";
import { PURCHASE_MANAGER_GROUP_IDS } from "@erp/shared/const/group-capability.const";
import { requiredInputRule } from "@erp/shared/utils/form/rules";
import { formatDate, formatHour } from "@erp/shared/utils/date/formatted-date";
export var TAB_MAIN_ITEMS;
(function (TAB_MAIN_ITEMS) {
    TAB_MAIN_ITEMS["PURCHASE_INBOUND"] = "\uAD6C\uB9E4 \uC785\uACE0";
    TAB_MAIN_ITEMS["GENERAL_INBOUND"] = "\uC77C\uBC18 \uC785\uACE0";
    TAB_MAIN_ITEMS["RETURN_INBOUND"] = "\uC7AC\uC785\uACE0";
})(TAB_MAIN_ITEMS || (TAB_MAIN_ITEMS = {}));
export const tabItems = [
    TAB_MAIN_ITEMS.PURCHASE_INBOUND,
    TAB_MAIN_ITEMS.GENERAL_INBOUND,
    TAB_MAIN_ITEMS.RETURN_INBOUND,
];
/**
 * @description 입고 신청 시 입력 필드
 */
export const inboundCardInfoInputs = [
    {
        label: "입고일자",
        key: "inboundDate",
        column_name: "inboundDate",
        type: "dateSingle",
        value: formatDate(),
        col: "12",
        sm: "3",
        lg: "3",
        menu: "",
        rules: [requiredInputRule],
    },
    {
        label: "입고시간",
        key: "inboundTime",
        column_name: "inboundTime",
        type: "hour",
        value: formatHour(),
        col: "12",
        sm: "3",
        lg: "3",
        rules: [requiredInputRule],
    },
    {
        label: "프로젝트 코드",
        key: "projectCode",
        type: "auto",
        column_name: "projectCode",
        col: "12",
        sm: "3",
        lg: "3",
        list: [],
        value: "",
    },
    {
        label: "입고사유 / 비고",
        key: "note",
        column_name: "note",
        type: "textarea",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        clearable: true,
        rules: [requiredInputRule],
    },
    {
        label: "수입검사서",
        key: "receivingInspection",
        column_name: "receivingInspection",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
        clearable: true,
        value: null,
    },
    {
        label: "시험성적서",
        key: "inspectionReport",
        column_name: "inspectionReport",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
        clearable: true,
        value: null,
    },
    {
        label: "기타",
        key: "etcFiles",
        column_name: "etcFiles",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        multiple: true,
        clearable: true,
        value: null,
    },
];
/**
 * @description 입고 신청 시 선택할 유저 정보
 */
export const inboundMemberInfo = [
    {
        type: MEMBER_TYPE.확인,
        givenName: "",
        id: null,
        email: "",
        userName: "",
    },
    {
        type: MEMBER_TYPE.승인,
        givenName: "",
        id: null,
        email: "",
        userName: "",
    },
    {
        type: MEMBER_TYPE.구매담당자,
        givenName: "",
        id: null,
        email: "",
        userName: "",
        groupIds: [...PURCHASE_MANAGER_GROUP_IDS],
    },
    {
        type: MEMBER_TYPE.자재담당자,
        givenName: "",
        id: null,
        email: "",
        userName: "",
    },
];
/**
 * @description 입고할 데이터 테이블 헤더 정보
 */
export const productInboundHeaders = [
    { text: "종류", align: "center", value: "type" },
    { text: "분류", align: "center", value: "classification" },
    { text: "관리코드", align: "center", value: "productCode" },
    { text: "제품명", align: "center", value: "name" },
    { text: "규격", align: "center", value: "spec" },
    { text: "모델명", align: "center", value: "model" },
    { text: "제조사", align: "center", value: "manufacturer" },
    { text: "단가", align: "start", value: "unitPrice" },
    { text: "입고수량", align: "center", value: "num" },
    { text: "입고장소", align: "center", value: "spot" },
    { text: "제외", align: "center", value: "" },
];
export const emptyRowCheck = {
    validator: (inboundItems) => inboundItems && inboundItems.length > 0,
    errorMessage: "자재를 선택해주세요.",
};
